import { ProjectRenderer } from './ProjectRenderer';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { OutlinePass } from './shaders/OutlinePass';
import { OutputPass } from 'three/examples/jsm/postprocessing/OutputPass.js';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
import { ACESFilmicToneMappingShader } from 'three/examples/jsm/shaders/ACESFilmicToneMappingShader.js';
import { Color, Vector2 } from 'three';
import { Pass } from 'three/examples/jsm/postprocessing/Pass.js';
import { RENDERER_CONFIG } from '@/configs/rendererConfig';

export class Postprocessing {
	composer: EffectComposer;
	outlinePass: OutlinePass;
	private outputPass: OutputPass;
	private effectFXAA: ShaderPass;
	private toneMappingPass: ShaderPass;

	constructor(private renderer: ProjectRenderer) {
		this.composer = new EffectComposer(renderer.renderer);

		const renderPass = new RenderPass(
			renderer.scene,
			renderer.cameraController.camera
		);
		renderPass.clearColor = new Color(RENDERER_CONFIG.SCENE_BACKGROUND);

		const renderTargetSize = this.renderer.renderer.getSize(new Vector2());

		this.outlinePass = new OutlinePass(
			new Vector2(renderTargetSize.x, renderTargetSize.y),
			this.renderer.scene,
			this.renderer.cameraController.camera
		);
		this.outlinePass.visibleEdgeColor.set(
			new Color(RENDERER_CONFIG.OUTLINE_PARAMS.visibleEdgeColor)
		);
		this.outlinePass.hiddenEdgeColor.set(
			new Color(RENDERER_CONFIG.OUTLINE_PARAMS.hiddenEdgeColor)
		);
		this.outlinePass.edgeStrength = RENDERER_CONFIG.OUTLINE_PARAMS.edgeStrength;
		this.outlinePass.edgeGlow = RENDERER_CONFIG.OUTLINE_PARAMS.edgeGlow;
		this.outlinePass.edgeThickness =
			RENDERER_CONFIG.OUTLINE_PARAMS.edgeThickness;
		this.outlinePass.pulsePeriod = RENDERER_CONFIG.OUTLINE_PARAMS.pulsePeriod;

		this.toneMappingPass = new ShaderPass(ACESFilmicToneMappingShader);
		this.toneMappingPass.uniforms['exposure'].value = 0.8;

		this.outputPass = new OutputPass();
		this.effectFXAA = new ShaderPass(FXAAShader);

		this.composer.addPass(renderPass);
		this.composer.addPass(this.outlinePass as Pass);
		this.composer.addPass(this.toneMappingPass);
		this.composer.addPass(this.effectFXAA);
		this.composer.addPass(this.outputPass);
	}

	handleResize() {
		const renderTargetSize = this.renderer.renderer.getSize(new Vector2());
		this.composer.setSize(renderTargetSize.x, renderTargetSize.y);
		this.effectFXAA.uniforms['resolution'].value.set(
			1 / renderTargetSize.x,
			1 / renderTargetSize.y
		);
	}
}
